import { AvForm } from 'availity-reactstrap-validation';
import React, { useEffect, useState } from 'react';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';
import { Label, FormGroup } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  loginUser,
  resetPassword,
  resetStatus,
  updatePasswordUsers,
} from '../../store/actions';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import IButtonComponent from '../../components/Common/iComponents/iButton/IButton';

const FormChangePsw = ({ email, onCancel, onPasswordChanged }: any) => {
  const { currentPswStatus, loading } = useSelector((state: any) => ({
    currentPswStatus: state.login.currentPswStatus,
    loading: state.login.loading,
  }));
  const [showInputCurrentPsw, setShowInputCurrentPsw] = useState<any>(true);
  const [state, setState] = useState({
    validSecondPassword: false,
    password: '',
    secondPassword: '',
  });
  const [currentPsw, setCurrentPsw] = useState({ password: '', email: email });
  const dispatch = useDispatch();

  useEffect(() => {
    if (state.password != '') {
      if (state.secondPassword === state.password) {
        setState({ ...state, validSecondPassword: true });
      } else {
        setState({ ...state, validSecondPassword: false });
      }
    }
  }, [state.secondPassword, state.password]);

  useEffect(() => {
    if (currentPswStatus === 'Success') {
      setShowInputCurrentPsw(false);
    } else if (currentPswStatus === 'Fail') {
      Swal.fire({
        icon: 'warning',
        title: 'Password Invalid!!!',
        text: 'The password is not valid!',
      }).then(() => {
        //onCancel();
      });
    }
  }, [currentPswStatus]);

  const LoadingIndicator = () => {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  };

  const handleChangePsw = () => {
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
      user = JSON.parse(getAuthUser);
    }
    dispatch(
      updatePasswordUsers({
        id: user.id,
        USUARIO_PASSWORD: state.password,
        select: 1,
      }),
    );
    Swal.fire({
      icon: 'success',
      title: 'Success!!!',
      text: 'The password was changed!!!',
    }).then(() => {
      onCancel();
    });
    onPasswordChanged();
  };
  const ValidateCurrentPsw = () => {
    dispatch(resetPassword(currentPsw));
  };
  return (
    <>
      <AvForm
        className="custom-form mt-0"
        style={{
          display: 'grid',
          gridAutoRows: 'minmax(1%, 60px)',
          padding: '0',
          marginLeft: '5%',
          marginRight: '5%',
          paddingTop: '2%',
        }}
      >
        <div>
          {showInputCurrentPsw ? (
            <>
              <Label style={{ marginTop: '12%' }} className="text-capitalize">
                Current Password
              </Label>
              <IInput
                title={'Current Password'}
                valid={currentPsw.password != '' ? true : false}
                // value={value}
                type={'Password'}
                onChangeHandler={(e) => {
                  setCurrentPsw({ ...currentPsw, password: e.target.value });
                }}
              />
              <IButtonComponent
                className="btn-search"
                actionOnClick={ValidateCurrentPsw}
                label={'Confirm'}
                // btnIcon='bx bx-search'
              ></IButtonComponent>
            </>
          ) : null}
        </div>
        {loading ? LoadingIndicator() : null}
        <div>
          {!loading ? (
            currentPswStatus === 'Success' ? (
              <div className="Inputs-changePsw">
                <Label style={{ marginTop: '0px' }} className="text-capitalize">
                  New Password
                </Label>
                <IInput
                  title={'New Password'}
                  valid={state.password != '' ? true : false}
                  value={state.password}
                  type="password"
                  onChangeHandler={(e) => {
                    setState({ ...state, password: e.target.value });
                  }}
                />
                <Label style={{ marginTop: '5%' }} className="text-capitalize">
                  Repeat New Password
                </Label>
                <IInput
                  title={'New Password'}
                  valid={state.validSecondPassword}
                  value={state.secondPassword}
                  type="password"
                  onChangeHandler={(e) => {
                    setState({ ...state, secondPassword: e.target.value });
                  }}
                />
                <IButtonComponent
                  className="btn-search"
                  actionOnClick={handleChangePsw}
                  label={'Change Password'}
                  disabled={!state.validSecondPassword}
                ></IButtonComponent>
              </div>
            ) : null
          ) : null}
        </div>
      </AvForm>
    </>
  );
};
FormChangePsw.propTypes = {
  email: PropTypes.string,
  onCancel: PropTypes.func,
  onPasswordChanged: PropTypes.func,
};
export default FormChangePsw;
